<template>
  <div class="authentication">
    <van-nav-bar
      title="实名认证"
      left-arrow
      fixed
      placeholder
      @click-left="$router.go(-1)"
    />
    <div class="main">
      <p class="tips">
        认证信息将用于开直播、收益提现等，与账号唯一绑定，我们会对信息进行严格保密
      </p>

      <div style="margin-top: 20px">
        <van-field
          v-model="form.realName"
          label="真实姓名"
          placeholder="请输入您的真实姓名"
        />
        <van-field
          v-model="form.idNumber"
          label="身份证号"
          placeholder="请输入身份证号"
        />
      </div>

      <div class="agreement">
        <van-checkbox v-model="agree" checked-color="#ee0a24" icon-size="16px"
          >已阅读并同意<span style="color: #3235dd"
            >《人脸验证服务协议》</span
          ></van-checkbox
        >
      </div>

      <div class="btn" :class="{ disabled }" @click="onClick">
        同意协议并认证
      </div>
    </div>
  </div>
</template>

<script>
import "vant/lib/index.css";
import { NavBar, Field, Checkbox, Toast } from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Toast.name]: Toast,
  },
  props: {
    form: Object,
  },
  data() {
    return {
      agree: false,
    };
  },
  computed: {
    disabled() {
      return !this.form.realName || !this.form.idNumber || !this.agree;
    },
  },
  methods: {
    onClick() {
      if (this.disabled) return;
      this.form.isAuthentication = true;
      Toast("认证成功");
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.authentication {
  .main {
    padding: 15px;
    .tips {
      color: #909399;
      font-size: 13px;
    }
    ::v-deep .van-field {
      padding-left: 0;
      background-color: transparent;
      border-bottom: solid 1px #e4e7ed;
      .van-field__label {
        font-weight: bold;
        color: #303133;
        letter-spacing: 5px;
      }
    }
  }
  .agreement {
    margin-top: 25px;
  }
  .btn {
    margin-top: 10px;
    padding: 10px 0;
    text-align: center;
    color: #fff;
    background-color: #e21e48;
    border-radius: 3px;
    user-select: none;
    cursor: pointer;
    &.disabled {
      background-color: #909399;
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
}
</style>